import {
  FETCH_LIST_ROLES_FOR_CREATING_ROLES_REQUEST,
  FETCH_LIST_ROLES_FOR_CREATING_ROLES_SUCCESS,
  FETCH_LIST_ROLES_FOR_CREATING_ROLES_FALUIRE,
} from './rolesForCreatingRoleListingTypes'

const initialState = {
  loading: false,
  allRolesForCreatingRoles: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LIST_ROLES_FOR_CREATING_ROLES_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LIST_ROLES_FOR_CREATING_ROLES_SUCCESS : return {
      ...state,
      allRolesForCreatingRoles: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LIST_ROLES_FOR_CREATING_ROLES_FALUIRE : return {
      ...state,
      loading: false,
      allRolesForCreatingRoles: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
